import styled from "styled-components";
import { themes } from "../../Utils/themes";
import { device } from "../../Utils/device";

export const ListWrap = styled.div`
  max-width: 930px;
  margin: 0 auto;
`;

export const NeedField = styled.div`
  background-color: ${themes.colors.background};
  border-radius: 8px;
  padding: 10px;
  font-weight: bold;
  color: #878787;
  margin: 0 auto;
  @media ${device.desktop} {
    padding: 10px 30px;
    margin-top: 10px;
    max-width: 1180px;
  }
`;

export const SmallDescription = styled.p`
  display: block;
  font-size: ${themes.textSize.s2};
  margin-top: 7px;
  margin-bottom: 7px;
  @media ${device.desktop} {
    font-size: ${themes.textSize.s3};
  }
`;
export const AccordionListWrap = styled.div`
  padding: 20px 20px 0;
  border-radius: 8px;
  @media ${device.desktop} {
    margin-top: 20px;
  }
`;
